import type { ICountry, IState } from 'country-state-city';
import { State, Country } from 'country-state-city';

const listOfSupportedCountries = [
  'IL',
  'CA',
  'AT',
  'IT',
  'BE',
  'LV',
  'BG',
  'LT',
  'HR',
  'LU',
  'CY',
  'MT',
  'CZ',
  'NL',
  'DK',
  'PL',
  'EE',
  'PT',
  'FI',
  'RO',
  'FR',
  'SK',
  'DE',
  'SI',
  'GR',
  'ES',
  'HU',
  'SE',
  'IE',
  'GB',
  'MF',
  'MQ',
  'RE',
  'YT',
  'IS',
  'NO',
  'LI',
  'CH',
  'AU',
  'US',
  'NZ',
  'BR',
  'JP',
  'SG',
  'MX',
  'BY',
  'KR',
  'CL',
  'AR',
  'CO',
  'TR',
  'AE',
  'MK',
  'IN',
];

export const Countries = Country.getAllCountries()
  .filter((f) => listOfSupportedCountries.includes(f.isoCode.toUpperCase()))
  .map((x: ICountry) => {
    const obj = {
      key: x.name,
      value: x.name,
      code: x.isoCode,
      states: [],
    };

    obj.states = State.getStatesOfCountry(x.isoCode).map((y: IState) => ({
      key: y.name,
      value: y.name,
    }));

    return obj;
  });
